import { GlobalConfig } from "@/stores/slices/commonSlice";
import { UploadConfig, UploadFormat } from "../core/types";
import { readFileChunk } from "@/lib/getFileHash";
import { UPLOAD_CONCURRENCY } from "../core/upload-concurrency";

const FALLBACK_CONFIG = {
	MAX_FILE_SIZE: 50,
	MAX_FILES: 10,
	MAX_VIP_FILES: 100,
};

export const DEFAULT_UPLOAD_FORMATS: UploadFormat[] = [
	{
		accept: "application/pdf",
		extensions: [".pdf"],
		validator: isPDFContent,
	},
];

export function getUploadConfig(
	globalConfig: GlobalConfig | null,
	vipLevel: number,
	overrides?: Partial<UploadConfig>,
): UploadConfig {
	const base: UploadConfig = {
		formats: overrides?.formats ?? DEFAULT_UPLOAD_FORMATS,
		maxFileSize: overrides?.maxFileSize
			?? globalConfig?.pdfMaxSize
			?? FALLBACK_CONFIG.MAX_FILE_SIZE,
		maxFiles: overrides?.maxFiles ?? getMaxCount(globalConfig, vipLevel),
		maxTotal: overrides?.maxTotal ?? getMaxCount(globalConfig, vipLevel),
		concurrency: overrides?.concurrency ?? UPLOAD_CONCURRENCY,
	};

	return base;
}

export function getAcceptFormatsText(formats: UploadFormat[]): string {
	if (!formats.length) {
		return "";
	}

	const extensionSet = new Set<string>();
	formats.forEach((format) => {
		format.extensions.forEach((ext) => extensionSet.add(ext.replace(/^\./, "")));
	});

	return Array.from(extensionSet).join("/").toUpperCase();
}

export async function isPDFContent(file: File): Promise<boolean> {
	const bytes = await readFileChunk(file.slice(0, 1024));
	for (let i = 0; i < bytes.length - 3; i += 1) {
		if (
			bytes[i] === 0x25
			&& bytes[i + 1] === 0x50
			&& bytes[i + 2] === 0x44
			&& bytes[i + 3] === 0x46
		) {
			return true;
		}
	}

	return false;
}

function getMaxCount(globalConfig: GlobalConfig | null, vipLevel: number): number {
	if (vipLevel === 0) {
		return globalConfig?.maxSummaryCount ?? FALLBACK_CONFIG.MAX_FILES;
	}
	return globalConfig?.maxVipSummaryCount ?? FALLBACK_CONFIG.MAX_VIP_FILES;
}

